import { Button, EmptyState } from '@recipes/ui';
import { SearchX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { PageHeader } from './page-header';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-lg p-6" data-testid="not-found-page">
      <PageHeader title={t('dashboard.notFound.title')} className="sr-only" />
      <EmptyState
        icon={<SearchX />}
        title={t('dashboard.notFound.title')}
        description={t('dashboard.notFound.description')}
        action={
          <Button asChild>
            <Link to="/">{t('dashboard.notFound.home')}</Link>
          </Button>
        }
      />
    </div>
  );
}
